import cn from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

interface Props {
  className?: string
  activeClassName?: string
  inactiveClassName?: string
  id: number
  activeTab: number
  url?: string
  onSelectTab?: (tabId: number) => void
  children?: React.ReactNode
  width?: string
}

export const TopicCategoriesTab: React.FC<Props> = ({
  id,
  activeTab,
  activeClassName,
  inactiveClassName,
  className,
  children,
  width,
  url,
  onSelectTab,
}) => {
  const router = useRouter()

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      if (onSelectTab) {
        onSelectTab(id)
      } else if (url) {
        router.push(url)
      }
    }
  }

  const handleClick = (e: React.MouseEvent) => {
    if (onSelectTab) {
      e.preventDefault()
      onSelectTab(id)
    }
  }

  const tabClassName = cn(
    `p-[20px] flex flex-col justify-center text-center font-primary font-bold text-[1.0rem] w-[${width ? width : '170px'}]`,
    activeTab === id ? 'border-b-[3px] border-b-navy' : '',
    className,
    activeTab === id ? activeClassName : inactiveClassName,
  )

  const content = (
    <>
      {activeTab === id ? (
        <span className="m-auto text-[15px] text-textdark font-primary font-bold leading-[18px]">{children}</span>
      ) : (
        <span className="m-auto text-[15px] text-[#51648c] leading-[18px]">{children}</span>
      )}
    </>
  )

  if (onSelectTab) {
    return (
      <button
        type="button"
        tabIndex={0}
        role="tab"
        aria-label={`${children} tab`}
        aria-selected={activeTab === id}
        onKeyDown={handleKeyDown}
        onClick={handleClick}
        className={tabClassName}
      >
        {content}
      </button>
    )
  }

  return (
    <Link
      href={url!}
      tabIndex={0}
      role="tab"
      aria-label={`${children} tab`}
      aria-selected={activeTab === id}
      onKeyDown={handleKeyDown}
      className={tabClassName}
    >
      {content}
    </Link>
  )
}
